import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import CascoQuotationContainer from './CascoQuotationContainer';

const sortQuotationsAndNegotiatedQuotation = quotations => {
  const sourceQuotations = quotations.filter(x => !x.sourceInsuranceQuotationId);
  const negQuotations = quotations.filter(x => x.sourceInsuranceQuotationId);

  const newQuotations = [];
  negQuotations.forEach(quotation => {
    const sourceQuotation = sourceQuotations.find(x => x.id === quotation.sourceInsuranceQuotationId);
    if (sourceQuotation) {
      newQuotations.push(sourceQuotation);
      newQuotations.push(quotation);
    }
  });
  const sortedQuotations = sourceQuotations.sort((a, b) => {
    const conventionA = a.cascoQuotation.conventionInfo?.conventionName ? a.cascoQuotation.conventionInfo.conventionName.toLowerCase() : '';
    const conventionB = b.cascoQuotation.conventionInfo?.conventionName ? b.cascoQuotation.conventionInfo.conventionName.toLowerCase() : '';
    const insurerA = a.insurerName.toLowerCase();
    const insurerB = b.insurerName.toLowerCase();
    if (a.errorMessage !== null) return 1;
    if (a.cascoQuotation.insuranceAmount > b.cascoQuotation.insuranceAmount) return -1;
    if (a.cascoQuotation.insuranceAmount < b.cascoQuotation.insuranceAmount) return 1;
    if (insurerA === insurerB) {
      if (conventionA === conventionB) {
        if (a.period === b.period) {
          if (a.id > b.id) return 1;
          else return -1;
        }
        if (a.period > b.period) return 1;
        else return -1;
      }
      if (conventionA > conventionB) return 1;
      else return -1;
    }
    if (insurerA > insurerB) return 1;
    else return -1;
  });

  sortedQuotations.forEach(quotation => {
    if (!negQuotations.some(x => x.sourceInsuranceQuotationId === quotation.id)) newQuotations.push(quotation);
  });

  return newQuotations;
};

const CascoQuotationListCard = ({ quotations, negotiationLens, ownerApplicationCode, isReadOnly, quotationIsDirty }) => {
  const [lastModifiedQuotationId, setLastModifiedQuotationId] = useState(null);
  const quotationsAndNegotiatedQuotationSorted = useMemo(() => sortQuotationsAndNegotiatedQuotation(quotations), [quotations]);

  return (
    <Grid item container spacing={2}>
      {quotationsAndNegotiatedQuotationSorted.map(
        quotation =>
          !quotation.blacklistInfo && (
            <Grid item xs={12} md={6} xl={3} key={quotation.id}>
              <CascoQuotationContainer
                quotation={quotation}
                negotiationLens={negotiationLens}
                ownerApplicationCode={ownerApplicationCode}
                isReadOnly={isReadOnly}
                quotationIsDirty={quotationIsDirty}
                isLastModifiedQuotation={quotation.id === lastModifiedQuotationId}
                setLastModifiedQuotationId={setLastModifiedQuotationId}
              />
            </Grid>
          )
      )}
    </Grid>
  );
};

CascoQuotationListCard.propTypes = {
  quotations: PropTypes.array.isRequired,
  selectedQuotationId: PropTypes.number,
  negotiationLens: PropTypes.object.isRequired,
  ownerApplicationCode: PropTypes.string,
  isReadOnly: PropTypes.func.isRequired,
  quotationIsDirty: PropTypes.object.isRequired
};

export default CascoQuotationListCard;
